import "./Home.css";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";

const data = {
  technologies: [
    {
      name: "HTML",
      image: "/images/html.png",
    },
    {
      name: "CSS",
      image: "/images/css.png",
    },
    {
      name: "JavaScript",
      image: "/images/js.png",
    },
    {
      name: "React",
      image: "/images/react.png",
    },
    {
      name: "NodeJS",
      image: "/images/node.png",
    },
    {
      name: "SQL",
      image: "/images/sql.png",
    },
    {
      name: "MongoDB",
      image: "/images/mongodb.png",
    },
    {
      name: "Git",
      image: "/images/git.png",
    },
    {
      name: "Github",
      image: "/images/github.png",
    },
    {
      name: "Heroku",
      image: "/images/heroku.png",
    },
    {
      name: "Netlify",
      image: "/images/netlify.png",
    },
    {
      name: "Firebase",
      image: "/images/firebase.png",
    },
    {
      name: "Solodity",
      image: "/images/solidity.png",
    },
    {
      name: "C++",
      image: "/images/cpp.png",
    },
    {
      name: "Python",
      image: "/images/python.png",
    },
    {
      name: "Chakra-UI",
      image: "/images/chakra.jpeg",
    },
    {
      name: "Tailwind",
      image: "/images/tailwind.jpg",
    },
    {
      name: "Framer Motion",
      image: "/images/framer.png",
    },
  ],
};

const Home = () => {
  return (
    <motion.div
      className="h-wrapper"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.3 }}
    >
      <div className="h-left">
        <h1 className="h-title">
          Paras Aghija <br /> Web Developer
        </h1>
        <p className="h-desc">
          I am a web developer with a passion for creating beautiful and
          functional websites. I am a self-taught developer and I am always
          looking to learn new things. I like exploring different libraries and
          frameworks to create a better user experience. Explored various
          styling libraries but CHAKRA-UI is my favourite &#128153;. I am liking
          more of backend stuff now and will be exploring more of it.
        </p>

        <div className="h-technologies">
          {data.technologies.map((tech) => (
            <img className="tech-img" src={tech.image} alt={tech.name} />
          ))}
        </div>
      </div>

      <div className="h-right">
        <div className="nav-links">
          <Link to="/about">About</Link>
          <Link to="/skills">Skills</Link>
          <Link to="/projects">Projects</Link>
          <Link to="/experience">Experience</Link>
          <Link to="/contact">Contact</Link>

          <Link
            to={{
              pathname:
                "https://drive.google.com/file/d/1prN_b1xqmKTujhJFuMB8p01zGzvjkxUm/view?usp=sharing",
            }}
            target="_blank"
          >
            Resume
          </Link>
        </div>
      </div>
    </motion.div>
  );
};

export default Home;
